import { memo, useState } from 'react'
import { toast } from 'react-toastify'
import { clearMentorId } from '../../../../store/reducers/userReducer'

import { useDispatch } from 'react-redux'
import { Modal } from '../../../../adminPages/components/Modal/Modal'
import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'
import { useDeleteTwin } from '../../../../hooks/apiHooks/twinHooks'

interface IRemoveTwinProps {
  some?: string
}

const RemoveTwin: React.FC<IRemoveTwinProps> = memo(() => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { mutateAsync, isPending } = useDeleteTwin()

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const removeTwin = async (): Promise<void> => {
    try {
      const res = await mutateAsync()
      if (res.success) {
        setIsOpen(false)
        toast.success('Digital Twin removed successfully')
        dispatch(clearMentorId())
      }
    } catch (error) {
      console.error('Error removing twin:', error)
      toast.error('Failed to remove Digital Twin')
    }
  }

  return (
    <div className="mt-14">
      <button
        data-testid="remove-twin-open-btn"
        onClick={handleOpen}
        className="underline block mx-auto"
      >
        Not happy with it? Delete it
      </button>

      {isOpen && (
        <Modal title="Remove Digital Twin" onClose={handleClose}>
          <>
            <p className="text-white py-4 px-6">
              Are you sure you want to remove your Digital Twin? This action
              cannot be undone.
            </p>
            <div className="flex justify-end gap-4 border-t border-white/10 py-4 px-6">
              <button
                data-testid="remove-twin-cancel-btn"
                onClick={handleClose}
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                data-testid="remove-twin-confirm-btn"
                onClick={removeTwin}
                disabled={isPending}
                className="btn bg-red-600 text-white rounded-md hover:bg-red-700"
              >
                {isPending && <AnimatedSpinner className="mr-2" />}
                Remove
              </button>
            </div>
          </>
        </Modal>
      )}
    </div>
  )
})

export { RemoveTwin }
